import React, { useMemo } from 'react';
import clsx from 'clsx';

import { getAboutPlainText, sanitizeAboutHtml } from 'utils/aboutHtml';

import classes from './RichAboutContent.module.scss';

type Props = {
  content?: string | null;
  className?: string;
};

const looksLikeHtml = (value: string): boolean => /<[a-z][\s\S]*>/i.test(value);

export const RichAboutContent: React.FC<Props> = ({ content, className }) => {
  const trimmed = content?.trim() ?? '';
  const safeHtml = useMemo(
    () => (trimmed ? sanitizeAboutHtml(trimmed) : ''),
    [trimmed],
  );

  if (!trimmed || !getAboutPlainText(safeHtml || trimmed).trim()) {
    return null;
  }

  if (!looksLikeHtml(trimmed)) {
    return (
      <div className={clsx(classes.root, className)} data-rich-about>
        <p className={classes.plain}>{trimmed}</p>
      </div>
    );
  }

  return (
    <div
      className={clsx(classes.root, className)}
      data-rich-about
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
};
